import { ControlledSelect } from "@dune/ui";
import { useFormContext } from "react-hook-form";
import { useGetTPASocieties } from "../../api/queries/societies.queries";
import { AddOrUpdateContactFormModeProps } from "./ContactForm";
import { ContactFormData } from "./useAddContactForm";

export const TPAContactForm = ({ mode }: AddOrUpdateContactFormModeProps) => {
	const formMethods = useFormContext<ContactFormData>();
	const {
		control,
		formState: { errors },
	} = formMethods;

	const { data: tpaSocieties } = useGetTPASocieties("");

	return (
		<>
			<ControlledSelect
				control={control}
				name="tpaSocietyId"
				label="Société"
				options={tpaSocieties?.map((tpaSociety) => ({
					label: tpaSociety.denomination,
					value: tpaSociety.id,
				}))}
				placeholder="Sélectionner"
				error={errors.tpaSocietyId?.message}
				required
				disabled={mode === "update"}
			/>
		</>
	);
};
